import { CloseOutlined } from "@mui/icons-material";
import { Dialog, IconButton } from "@mui/material";

import { getExtension } from "../../../../../components/ui library/helpers/functions";

export default function ViewDocumentModal({
  viewDocument,
  closeDocModal,
  activeDoc,
}) {
  const fileExtension = getExtension(activeDoc.fileName);

  return (
    <Dialog open={viewDocument} fullScreen>
      <div className="p-8">
        <div className="flex justify-between mb-4" >
          <IconButton onClick={closeDocModal}>
            <CloseOutlined />
          </IconButton>
        </div>
        <div className="mx-auto my-0">
            {(!activeDoc.file || fileExtension === "") && (
                <p className="text-xl font-bold text-center">
                    No File Preview Available
                </p>
              )
            }
            {activeDoc.file && (
              <object
                  data={activeDoc.file}
                  aria-label={activeDoc.fileName}
                  style={{
                  width: "100%",
                  height: "100%",
                  display: "block",
                  minHeight: "80vh",
                  }}
              ></object>
              )
            }
          
        </div>
      </div>
    </Dialog>
  );
}